import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from './LanguageSelector';

interface ToolbarProps {
  onClearMap?: () => void;
}

export function Toolbar({ onClearMap }: ToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="h-20 border-b border-white/5 bg-black/30 backdrop-blur-md px-6 flex items-center justify-between shadow-2xl relative z-50">
      <div className="flex items-center gap-4">
        {/* Boho Logo */}
        <div className="flex flex-col">
          <img
            src="/logo-posterden.png"
            alt="POSTER'S DEN"
            className="h-12 w-auto object-contain"
          />
        </div>
      </div>

      <div className="flex items-center gap-6">
        <LanguageSelector />
        {onClearMap && (
          <button
            onClick={onClearMap}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-posterden-red hover:text-white hover:bg-posterden-red rounded-full transition-all duration-300 border border-posterden-red/20 hover:border-posterden-red"
            title="Start over"
          >
            <RotateCcw className="h-4 w-4" />
            <span className="hidden sm:inline">{t('toolbar.clearMap')}</span>
          </button>
        )}
      </div>
    </div>
  );
}

